module.exports = __webpack_public_path__ + "static/media/OrderNotificationMusic_User.0cd047f2.mp3";